import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=dfd4ffb6&scoped=true"
import script from "./departments.vue?vue&type=script&lang=js"
export * from "./departments.vue?vue&type=script&lang=js"
import style0 from "./departments.vue?vue&type=style&index=0&id=dfd4ffb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd4ffb6",
  null
  
)

export default component.exports